import { Injectable } from '@angular/core';
import { Activity, ActivityTagName } from '@jms/model';
import Enumerable from 'linq';

@Injectable()
export class ActivityLinkService {

    public isContractorLinked(activity: Activity): boolean {

        const contractorActivityId = Enumerable
            .from(activity.tags)
            .where(a => a.name === ActivityTagName.ContractorActivityId)
            .select(a => a.value)
            .firstOrDefault();

        return !!contractorActivityId;
    }

}